module.exports = __webpack_public_path__ + "img/coin-placeholder.3c146dce.png";